import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

// components
import { ButtonSimple } from '../../Elements/Buttons';

// svgs
import mugicsSVGCreature from './images/mugicsCreatureSVG';
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';

// styles
import '../stylesModal.css';
import './videomodal.css';
import {isMobile} from "../../../utils";

const VideoModal = ({ isModalOpen, closeModal, vidUrl, onClick }) => {
    if (isMobile()) {
        return (
            <div className="video-modal-wrapper">
                <Modal
                    isOpen={isModalOpen}
                    contentLabel="Modal"
                    className="modal-wrapper video-modal"
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        }}}
                >
                    <div onClick={closeModal} >
                        <SVGInline style={{right: 5}} className="close-button" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className="vid-wrapper" >
                        <iframe
                            src={vidUrl}
                            width={`${window.innerWidth}`}
                            height="450"
                            title={vidUrl}
                        />
                    </div>
                </Modal>
            </div>
        )
    }

    return (
        <div className="video-modal-wrapper">
            <Modal
                isOpen={isModalOpen}
                contentLabel="Modal"
                className="modal-wrapper video-modal rtl"
                style={{overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    }}}
            >
                <div onClick={closeModal} >
                    <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                </div>
                <div className="title">
                    <SVGInline component="i" svg={mugicsSVGCreature}/>
                    <div className="title-text">Mugics</div>
                </div>
                <div className="vid-wrapper">
                    <iframe
                        src={vidUrl}
                        width="900"
                        height="450"
                        title={vidUrl}
                    />
                </div>
                <ButtonSimple label="השתתפו!" onPress={() => onClick()} />
            </Modal>
        </div>
    )
};

// Viemo url example
// https://player.vimeo.com/video/65931040?autoplay=1&loop=1&background=1&frameborder=0

VideoModal.propTypes = {
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    vidUrl: PropTypes.string,
    onClick: PropTypes.func
};

export default VideoModal;



// WEBPACK FOOTER //
// ./src/Components/Modals/Video/VideoModal.js